// extracted by mini-css-extract-plugin
export default {"dialogContent":"comment_dialogContent__C6B2F","dialogForm":"comment_dialogForm__6q7Gs","buttonClose":"comment_buttonClose__oh9gl","buttonSecondary":"comment_buttonSecondary__ia6u0"};